/**
 * Returns whether vendor-related UI should be read-only for an **existing vendor** flow.
 */
export function isVendorFieldsLockedForExistingVendor(
  hasExistingVendor?: boolean | null
): boolean {
  return hasExistingVendor === true;
}
